<div
  [hidden]="!showDropdown"
  ngbDropdown
  placement="bottom-end"
  class="aa-dropdown ms-2"
>
  <button
    type="button"
    id="export-button"
    class="btn btn-outline mb-1"
    [class.btn-sm]="size === 'small'"
    ngbDropdownToggle
    [disabled]="disabled"
  >
    <i-lucide name="download"></i-lucide>
    {{ description || 'Export' }}
  </button>

  <div ngbDropdownMenu aria-labelledby="export-button">
    <button
      type="button"
      ngbDropdownItem
      (click)="onExportClick()"
      [trackingEvent]="'Export Grid  - CSV'"
    >
      As CSV
    </button>

    <ng-content></ng-content>
  </div>
</div>

@if (!showDropdown) {
  <button
    type="button"
    id="export-csv-button"
    class="btn btn-outline mb-1 ms-2"
    [class.btn-sm]="size === 'small'"
    [disabled]="disabled"
    (click)="onExportClick()"
    [trackingEvent]="'Export Grid  - CSV'"
  >
    <i-lucide name="download"></i-lucide>
    {{ description || 'Export CSV' }}
  </button>
}
